import React, { useMemo } from 'react'
import { Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Body2 } from 'components'
import { toBankTz } from 'utils/date.utils'
import { StyledAvatar } from 'components/StatusBadge/Styled'
import { ProductStatus } from 'store/products/typings/productStatus'
import { ProductVersionStatus } from 'store/products/typings/productVersionStatus'

interface OwnProps<FilterItem> {
  isActive: boolean
  items: FilterItem[]
  isLive?: boolean
  effectiveDatePropName?: string
}

const ScheduledMenuItem = <FilterItem extends { status: ProductStatus | ProductVersionStatus }>({
  isActive,
  items,
  isLive = false,
  effectiveDatePropName = 'effectiveDate',
}: OwnProps<FilterItem>) => {
  const { t } = useTranslation()

  const itemsLength = useMemo(
    () =>
      isLive
        ? items.filter(
            (item) =>
              item.status === ProductStatus.LIVE &&
              item[effectiveDatePropName] &&
              !toBankTz(item[effectiveDatePropName]).isAfterNow
          ).length
        : items.filter(
            (item) =>
              item.status === ProductStatus.LIVE &&
              item[effectiveDatePropName] &&
              toBankTz(item[effectiveDatePropName]).isAfterNow
          ).length,
    [items]
  )

  // we need a date that is always in the future to trigger scheduled icon
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth()
  const day = today.getDate()
  const futureDate = new Date(year, month + 1, day).toUTCString()

  const label = isLive ? t('Live') : t('Scheduled')

  return (
    <Box component="span" display="flex">
      <StyledAvatar status={ProductStatus.LIVE} parsedDate={!isLive ? toBankTz(futureDate) : undefined} />
      <Body2 color={!isActive ? 'textPrimary' : undefined}>
        {label} ({itemsLength})
      </Body2>
    </Box>
  )
}
export default ScheduledMenuItem
